<template lang="pug">
b-modal#modal-pop-up-script(title='貼り付け用タグを取得')
  .callout.callout-info
    p
      | 以下のタグを離脱防止ポップアップを表示したいWebページに設置してください。
      br/
      | Webページのbody内に設置した場合、該当Webページのみ、head内に設置した場合、headを共有している全てのWebページでポップアップが表示されます。
      br/
      | タグ設置方法は
      a(class="text-primary", href="https://docs.google.com/presentation/d/1KpAYhUqPNecSY-hVYmDiLVE6omAjmDcQspgZnOYY988/edit?usp=sharing", target="_blank") こちら
      | をご参照ください。
  .row
    textarea.form-control(rows=5)
      | <script type="text/javascript" charset="utf-8" src="{{$store.state.pop_up.url}}"></script>
</template>

<script>
import Vue from 'vue'

export default {
  methods: {
  },
  components: {
  },
  async mounted(){
    await Vue.nextTick()
  },
}
</script>
<style lang="scss" scoped>
</style>
